import { render, staticRenderFns } from "./Payment.vue?vue&type=template&id=779d3fb0&"
import script from "./Payment.vue?vue&type=script&lang=ts&"
export * from "./Payment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports